import styled, { CSSObject } from 'styled-components';
import getIconSize from './getIconSize';
import { Size } from './types';

interface SvgIconStyledProps {
  color?: 'primary' | 'secondary' | 'wfWhite' | 'wfBlack' | 'minimal';
  size?: keyof typeof Size;
  sx?: CSSObject;
}

const SvgIconStyled = styled.span<SvgIconStyledProps>(
  ({ theme, size, color, sx }) => {
    // eslint-disable-next-line no-nested-ternary
    const iconColor = color
      ? color === 'minimal'
        ? theme.color.wfGrey600
        : theme.color[color]
      : '';

    const styleSheet: CSSObject = {
      display: 'inline-flex',
      svg: {
        ...getIconSize(size),
        path: {
          fill: iconColor,
        },
      },
    };

    // TODO: try new approach
    // const styleSheet: CSSObject = {
    //   display: 'inline-flex',
    //   svg: {
    //     ...getIconSize(size),
    //     color: iconColor,
    //     path: {
    //       fill: 'currentColor',
    //     },
    //   },
    // };

    return {
      ...styleSheet,
      ...sx,
    };
  },
);

export { SvgIconStyled };
